import { useRef, useState } from "react";
import { useTerminFotos } from "../../hooks/usePlanung";
import { errorText } from "../../lib/invoices";
import { btnGhost } from "./planer-styles";

/**
 * Baustellenfotos zu einem Termin — der Weg, den auch die Helfer benutzen.
 *
 * Bewusst ohne jedes Eingabefeld: Projekt und Arbeitstag stehen im Termin, die
 * Ablage ist immer der Verlauf. Wer ein Bild macht, soll es abgeben koennen,
 * ohne vorher eine Phase zu waehlen.
 *
 * `capture` steht absichtlich NICHT am Feld: damit oeffnet das Telefon direkt
 * die Kamera und die Fotomediathek ist nicht mehr erreichbar — Bilder werden
 * aber meist waehrend der Arbeit gemacht und erst spaeter abgegeben.
 */
export function TerminFotos({ terminId, hatProjekt }: { terminId: string; hatProjekt: boolean }) {
  const feld = useRef<HTMLInputElement | null>(null);
  const [zuletzt, setZuletzt] = useState<number | null>(null);
  const upload = useTerminFotos(terminId);

  const waehle = (liste: FileList | null) => {
    const dateien = Array.from(liste ?? []);
    if (!dateien.length) return;
    setZuletzt(null);
    upload.mutate({ dateien }, { onSuccess: (res) => setZuletzt(res.count) });
    // Zuruecksetzen, sonst loest dieselbe Datei beim zweiten Mal nichts aus.
    if (feld.current) feld.current.value = "";
  };

  return (
    <div className="tm-fotos">
      {/* Eine Zeile statt eines eigenen Abschnitts (13.10.2026). */}
      <div className="tm-fotos-zeile">
      <span className="tm-fotos-titel">Fotos von der Baustelle</span>

      <input
        ref={feld}
        type="file"
        accept="image/*"
        multiple
        onChange={(e) => waehle(e.target.files)}
        style={{ display: "none" }}
      />

      <button
        type="button"
        onClick={() => feld.current?.click()}
        disabled={upload.isPending || !hatProjekt}
        style={{ ...btnGhost, opacity: upload.isPending || !hatProjekt ? 0.5 : 1, minHeight: 44 }}
        title={hatProjekt ? undefined : "Erst wenn der Termin an einem Projekt haengt, gibt es einen Ablageort"}
      >
        {upload.isPending ? "Lädt hoch…" : "＋ Fotos"}
      </button>
      </div>

      {!hatProjekt && (
        <div style={{ marginTop: 8, fontSize: 12.5, color: "var(--vg-text-3)" }}>
          Ein Besichtigungstermin hat noch kein Projekt — und damit keinen Ordner, in den die
          Bilder gehören. Sobald daraus ein Projekt geworden ist, geht es hier.
        </div>
      )}

      {upload.isError && (
        <div style={{ marginTop: 8, fontSize: 12.5, color: "var(--vg-red)" }}>
          {errorText(upload.error)}
        </div>
      )}

      {zuletzt !== null && !upload.isError && (
        <div style={{ marginTop: 8, fontSize: 12.5, color: "var(--vg-green)" }}>
          {zuletzt === 1 ? "Ein Foto abgelegt." : `${zuletzt} Fotos abgelegt.`} Zu sehen in der
          Projektakte unter „Dokumentation".
        </div>
      )}
    </div>
  );
}
